import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace DataDictionary {
    /**
    * 获取所需字典项数据
    */
    export var GetDicDetailList = (query: any): Promise<any> => {
        return Get(`/msls/DataDictionary/GetDicDetailList?${qs.stringify(query)}`, {});
    };


}
